export enum HttpMethod {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  PATCH = 'PATCH',
  DELETE = 'DELETE',
}



// WEBPACK FOOTER //
// ./src/app/shared/enums/http-methods.enum.ts